/**
 * Доля хвоста публичного рендерера: вид `photo_upload` (загрузка фото).
 *
 * WEB-2920, заход 4: перенесено из `PublicBlockRendererExtended.tsx` слово в
 * слово. Метка `case 'photo_upload'` остаётся в фасаде; ветка вида — функция
 * отрисовки `renderPhotoUpload(ctx)`. Замыкания фасада приходят объектом-контекстом
 * (`ExtendedRenderContext`); ответ посетителя ветка читает из `values` и пишет
 * через `setValue` — это `useFormValues()` фасада: хук стоит до `switch`, в
 * функции отрисовки его звать нельзя (рисуется одна ветка за рендер). Эту
 * долю импортирует только фасад: она едет в ленивом куске `extended`, а не в
 * первом экране (самопроверка обхода).
 */
import React from 'react';
import { aiFields } from '../aiShapedFields';
import { photoUploadMaxSizeText } from '@/utils/publicExtendedBlockStrings';
import type { ExtendedRenderContext } from '../PublicBlockRendererExtended';

export function renderPhotoUpload(
  ctx: ExtendedRenderContext,
): React.ReactElement {
  const { block, varCtx, primaryColor, richText, hasText, setValue } = ctx;
  const ai = aiFields(block);
  const question = block.photoUploadQuestion ?? ai.question;
  const maxSizeMb = block.photoUploadMaxSizeMb ?? ai.maxSizeMb;
  const accept = block.photoUploadAccept ?? ai.accept ?? ['image/*'];
  return (
    <div data-testid="photo-upload" style={{ marginBottom: 16 }}>
      {hasText(question) && (
        <label
          style={{
            display: 'block',
            fontWeight: 600,
            marginBottom: 8,
            color: primaryColor,
            ...(block.fontSize ? { fontSize: block.fontSize } : {}),
          }}
        >
          {/* WEB-809: photoUploadQuestion is rich (was a plain interp()). */}
          {richText(question)}
        </label>
      )}
      <input
        type="file"
        accept={accept.join(',')}
        data-testid="photo-upload-input"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const file = e.target.files?.[0];
          if (file) setValue(block.id, file.name);
        }}
        style={{ display: 'block', width: '100%' }}
      />
      {maxSizeMb && (
        <div
          style={{
            fontSize: 12,
            color: 'var(--color-text-secondary, #8c8c8c)',
            marginTop: 4,
          }}
        >
          {/* WEB-2942: было зашито по-английски и для русской воронки. */}
          {photoUploadMaxSizeText(varCtx?.system?.locale, maxSizeMb)}
        </div>
      )}
    </div>
  );
}
